import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/allSuperintendentsForFieldReportFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/allSuperintendentsForFieldReportFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/allSuperintendentsForFieldReportFilter`;
